// FILE: apps/website/src/pages/cabinet/components/PortfolioHoldingCard.tsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Button } from '@dopomogai/ui';
import type { PortfolioHolding } from '@dopomogai/types';

type Props = {
  holding: PortfolioHolding;
};

export function PortfolioHoldingCard({ holding }: Props) {
  const navigate = useNavigate();

  return (
    <Card>
      <div className="p-4 space-y-4">
        <div className="flex justify-between items-start">
          <h3 className="text-xl font-extrabold">{holding.agent_name}</h3>
          {/* You could add a performance badge here if desired */}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 text-center">
          <div className="bg-slate-50 border-2 border-black rounded-lg p-3">
            <div className="text-xs text-slate-600">Shares Owned</div>
            <div className="text-lg font-bold">{holding.total_shares_owned.toLocaleString()}</div>
          </div>
          <div className="bg-slate-50 border-2 border-black rounded-lg p-3">
            <div className="text-xs text-slate-600">Total Cost</div>
            <div className="text-lg font-bold">{holding.total_credits_invested.toLocaleString()} cr</div>
          </div>
          <div className="bg-slate-50 border-2 border-black rounded-lg p-3">
            <div className="text-xs text-slate-600">Current Value</div>
            <div className="text-lg font-bold">{holding.current_market_value_credits.toLocaleString()} cr</div>
          </div>
        </div>
        
        <div className="border-t-2 border-black pt-4 flex gap-3">
          <Button
            text="View Agent Details"
            variant="secondary"
            onClick={() => navigate(`/invest/${holding.agent_id}`)}
          />
        </div>
      </div>
    </Card>
  );
}